import { Row, TableFather, Wrapper } from "./TableStyle";
import { SimpleSelect } from "../SimpleSelect/SimpleSelect";
import Typogaphy from "../Typography/Typography";
import Button from "../Button/Button";
import AddProductDialog from "../Dialog/AddProductDialog";
import { InputField1 } from "../InputField1/InputField1";

export const Table = ({
  items,
  headerTitle,
  title,
  detail,
  detailOrder,
  isShowAddModal,
  setIsShowAddModal,
  products,
  idOrderOnline,
  status,
  setSearch,
  handleChange,
  sortItems,
  sort,
  countPage,
  addCheckDesk,
  content,
  scroll,
  isPreviousData,
  handleNext,
  handlePrevios,
  PageNumber,
  paginate,
  dateFilter,
  height,
  addCheck,
  tfoot,
  setIsSort,
  isSort,
  className,
  shareBtn,
  noSearch,
  CrmUsers,
  tabs,
  change,
  handleNotifUpdate,
  JustSabt,
}) => {
  const handleClose = () => setIsShowAddModal(false);
  const pages = Math.ceil(countPage / 100);
  let numberPage = [];
  for (let i = 1; i <= pages; i++) {
    numberPage.push(i);
  }

  return (
    <TableFather
      scroll={scroll}
      top
      height={height}
      className={className}
      CrmUsers={CrmUsers}
    >
      <div className="card">
        {/* begin::Header */}
        <div className="pt-5 border-0 card-header">
          <div className="w-100">
            <Typogaphy size="14px" weight="bold">
              {title}
            </Typogaphy>
          </div>
          {detailOrder}
          <div className="mx-3">{shareBtn}</div>
          <div className="card-toolbar d-flex ">
            <div className="flex-fill row ">
              {/* <div className="search-field ">
                <GrSearch className="icon" />
                <input
                  className="form-control form-control-solid ps-14 tableSearchInput"
                  placeholder="جستجو کنید"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div> */}
              <div className="col-lg-4">
                {noSearch ? null : (
                  <InputField1
                    label="جستجو :"
                    placeholder="جستجو کنید..."
                    onChange={(e) => setSearch(e.target.value)}
                  />
                )}
                {addCheck}
              </div>
              {dateFilter}
            </div>
            {sort && (
              <div className="pagination-rate ">
                <SimpleSelect onChange={handleChange} items={sortItems} />
              </div>
            )}
          </div>
          {tabs ? tabs : ""}
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className="py-3 card-body">
          {/* begin::Table container */}
          <div className="table-responsive">
            {/* begin::Table */}
            <table className="table align-middle table-row-dashed table-row-gray-300 gs-0 gy-4">
              {/* begin::Table head */}
              <thead>
                <tr className="fw-bolder text-muted">
                  {/* <th className="">
                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="1"
                        data-kt-check="true"
                        data-kt-check-target=".widget-9-check"
                      />
                    </div>
                  </th> */}
                  {headerTitle?.map((item, index) => {
                    if (item === "نام و نام خانوادگی ^") {
                      return (
                        <th
                          style={{ cursor: "pointer" }}
                          className="min-w-150px"
                          key={index}
                          onClick={() => setIsSort({ name: !isSort?.name })}
                        >
                          {item}
                        </th>
                      );
                    } else if (item === "ردیف") {
                      return (
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSort({ row: !isSort?.row })}
                        >
                          {item}
                        </th>
                      );
                    } else if (item === "شماره تلفن") {
                      return (
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSort({ phone: !isSort?.phone })}
                        >
                          {item}
                        </th>
                      );
                    } else {
                      return (
                        <th className="min-w-150px" key={index}>
                          {item}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>{items}</tbody>
              {tfoot}
            </table>
          </div>
          {isShowAddModal && (
            <AddProductDialog
              handleClose={handleClose}
              show={isShowAddModal}
              idOrderOnline={idOrderOnline}
              setIsShowAddModal={setIsShowAddModal}
              products={products}
            />
          )}
        </div>
        <Row>
          {addCheckDesk}
          {detail ? (
            <div className="border-0 card-footer d-flex">
              {status === "JustSabt" && (
                <Button
                  small="150px"
                  bgColor="#0D6EFD"
                  color="#fff"
                  onclick={() => setIsShowAddModal(!isShowAddModal)}
                >
                  افزودن محصول
                </Button>
              )}
              {change === "true" && JustSabt === "JustSabt" && (
                <div className="mx-1">
                  <Button
                    small="120px"
                    bgColor="#0D6EFD"
                    color="#fff"
                    onclick={handleNotifUpdate}
                  >
                    تایید تغییرات
                  </Button>
                </div>
              )}
            </div>
          ) : paginate ? (
            <Wrapper>
              <Button
                bgColor="#0D6EFD"
                small="100px"
                color="#fff"
                onclick={handlePrevios}
                disabled={PageNumber === 1}
              >
                قبلی
              </Button>
              <Button
                bgColor="#50CD89"
                small="100px"
                color="#fff"
                disabled={isPreviousData}
                onclick={handleNext}
              >
                بعدی
              </Button>
            </Wrapper>
          ) : null}
        </Row>
        {content}
      </div>
    </TableFather>
  );
};
